import React from 'react';

type MarkLoadedOnMountProps = {
	onLoaded: () => void;
};

export const MarkLoadedOnMount = ({ onLoaded }: MarkLoadedOnMountProps): null => {
	const onLoadedRef = React.useRef(onLoaded);
	onLoadedRef.current = onLoaded;

	React.useEffect(() => {
		onLoadedRef.current();
	}, []);

	return null;
};
